import { useMutation } from "react-query";
import http from "infra/http";
import { UnidadeImportacao } from "./typings/unidade";
import { useInvalidateQuery } from "infra/packages/react-query";

function useSaveMultiplesUnidades(tenantId?: string) {
  const { doInvalidateQueryWithStringKey } = useInvalidateQuery();

  return useMutation(
    [`/v1/unidades/multiple`],
    (data: UnidadeImportacao[]) => {
      const headers: any = {};

      if (tenantId) {
        headers.tenant = tenantId;
      }

      return http.post(
        `/v1/unidades/multiple`,
        { items: data },
        {
          headers,
        }
      );
    },
    {
      retry: false,
      onSettled: () => {
        doInvalidateQueryWithStringKey("/v1/tenants/passos-cadastro");
      },
    }
  );
}

export default useSaveMultiplesUnidades;
